import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MdbChartDirective } from 'mdb-angular-ui-kit/charts';
import { ComponentBase } from 't4core';




@Component({
    selector: 'dbwidget-expiring-contracts',
    templateUrl: 'expiringContracts.html',
})
export class ExpiringContractsDBWidget extends ComponentBase implements OnInit {

    @ViewChild(MdbChartDirective, {static: false}) chartControl: MdbChartDirective;
    @Input() title: string = "";
    public isLoading: boolean = false;
    constructor() {
        super();
    }

  public async ngOnInit() {
    this.isLoading = true;
        var month = new Date().getMonth();
        this.chartLabels = this.chartLabels.slice(month).concat(this.chartLabels.slice(0, month + 1));

        var x = await this.Api.get<number[]>("/TurboOrder/GetExpiringContracts12M");
        this.chartDatasets[1] = {
            yAxisID: "y-axis-1",
            data: x,
            label: 'Trailers',
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: 'rgba(0,0,0,0.5)',
            lineTension: 0.35
        };

        var y = await this.Api.get<number[]>("/TurboOrder/GetUsedSales12M");
        this.chartDatasets[0    ] = {
            yAxisID: "y-axis-0",
            data: y,
            label: 'Sales',
            backgroundColor: 'rgba(151,187,205,0.2)',
            borderColor: 'rgba(151,187,205,1)',
            lineTension: 0.35
        };

    this.chartControl.update();
    this.isLoading = false;
    }

    public chartType: string = 'line';

    public chartDatasets: Array<any> = [{}, {}];

    public chartLabels: Array<any> = ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];

    public chartOptions: any = {
        responsive: true,
      scales: {
        y: {
          stacked: false,
          position: "left",
          id: "y-axis-0",
          ticks: {
            display: false
          }
        },      
        y1: {
          stacked: false,
          position: "right",
          id: "y-axis-1",
          ticks: {
            display: false,
            suggestedMax: 200
          }
        }
      },
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
    };

    public chartClicked(e: any): void {

    }

    public chartHovered(e: any): void {

    }
}
